import styled, {css} from "styled-components"

const Body = styled.div`
  ${({theme}) => css`
    flex-grow: 1;
    margin-right: 5px;
    margin-left: ${theme.spacing.one};
    ${theme.mediaQueries.minWidthMedia.tablet`
      margin-left: ${theme.spacing.four};
    `}
    max-width: 100%;
  `}
`

export default Body
